<mat-form-field subscriptSizing="dynamic">
    @if (!focused) {
        <span matTextPrefix>{{ currencyPrefix }}</span>
    }
    @if (ngControl?.control) {
        <input
            matInput
            [autocomplete]="autocomplete ? 'on' : 'off'"
            [placeholder]="placeholder"
            [formControl]="$any(ngControl!.control)"
            (input)="onChange($event)"
            [errorStateMatcher]="errorMatcher"
            (focus)="onFocus()"
            (blur)="onFocusOut()"
            currency
        />
    } @else {
        <input
            matInput
            [autocomplete]="autocomplete ? 'on' : 'off'"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [ngModel]="value"
            (input)="onChange($event)"
            (focus)="onFocus()"
            (blur)="onFocusOut()"
            currency
        />
    }

    @for (error of ngControl?.control?.errors | errorMessages; track error) {
        <mat-error>{{ error }}</mat-error>
    }
</mat-form-field>
